import { QueryResult } from 'react-query';
import { callApi, Controller, useApi, UseApiOptions } from './useApi';
// eslint-disable-next-line import/no-cycle
import { Kunde } from './kunde';
import { defaultSmDate } from '../utils/formatter';

export interface ArtikelDetailLieferant {
    lNr: number;
    artikelGruppeNr: number;
    artikelNr: string;
    lieferantArtikelNr: string;
    art: boolean;
    einheit: string;
    packEinheit: number;
    ekPreis: number;
    ekGiltAb: string;
    vkPreis: number;
    vkGiltAb: string;
    kalkPreisGrp: string;
    updDat?: string;
    updUhr?: number;
    updUser?: string;

    lieferant?: Kunde;
}

export const defaultArtikelDetailLieferant: ArtikelDetailLieferant = {
    lNr: -1,
    artikelGruppeNr: 0,
    artikelNr: '',
    lieferantArtikelNr: '',
    art: false,
    einheit: '',
    packEinheit: 0,
    ekPreis: 0,
    ekGiltAb: defaultSmDate,
    vkPreis: 0,
    vkGiltAb: defaultSmDate,
    kalkPreisGrp: '',
};

export interface ArtikelDetailLieferantFilter {
    artikelGruppeNr: number;
    artikelNr: string;
    lNr?: number;
    withLieferant?: boolean;
}

export async function getArtikelDetailLieferantList(
    filter: ArtikelDetailLieferantFilter,
): Promise<ArtikelDetailLieferant[]> {
    return callApi<ArtikelDetailLieferant[]>(Controller.artikelDetailLieferant + '/list', {
        filter,
    });
}

export function useArtikelDetailLieferant(
    filter: ArtikelDetailLieferantFilter,
    apiOptions?: UseApiOptions<ArtikelDetailLieferant>,
): QueryResult<ArtikelDetailLieferant> {
    return useApi<ArtikelDetailLieferant>(Controller.artikelDetailLieferant + '/one', { filter }, apiOptions);
}

export function useArtikelDetailLieferantList(
    filter: ArtikelDetailLieferantFilter,
    apiOptions?: UseApiOptions<ArtikelDetailLieferant[]>,
): QueryResult<ArtikelDetailLieferant[]> {
    return useApi<ArtikelDetailLieferant[]>(Controller.artikelDetailLieferant + '/list', { filter }, apiOptions);
}

export async function addArtikelDetailLieferant(artikelDetailLieferant: ArtikelDetailLieferant): Promise<void> {
    return callApi<void>(Controller.artikelDetailLieferant + '/add', { artikelDetailLieferant });
}

export async function updateArtikelDetailLieferant(artikelDetailLieferant: ArtikelDetailLieferant): Promise<void> {
    return callApi<void>(Controller.artikelDetailLieferant + '/update', { artikelDetailLieferant });
}
